/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { MaterialDivisionBase } from "../../../../schema/generated/MaterialDivision";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class MaterialDivisionDataApi extends EntityDataApi<MaterialDivisionBase> {
  public readonly def = idbEntityDefs.MaterialDivision;
}